import styled from '@emotion/styled/macro';
import { Handle } from '@xyflow/react';
import { colors, views } from '../../../../common/styles/theme.styles';

export const GhostNodeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 20px 8px 12px;
  background: transparent;
  border: 1px dashed ${colors.gray3};
  border-radius: 12px;
  min-width: 200px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  
  &:hover {
    border-color: ${colors.gray2};
    background: ${colors.lightGray1};
  }
  
  &.selected {
    background: ${colors.lightGray1};
  }
  
  ${views.mobile} {
    padding: 7px 24px 8px 16px;
    height: 56px;
    gap: 8px;
    background: #fff;
    svg {
      path {
        stroke: ${colors.gray2};
      }
    }
  }
`;

export const GhostEntityContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const GhostEntityName = styled.div`
  font-family: Circular;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  color: ${colors.gray2};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${views.mobile} {
    font-size: 15px;
    font-weight: 450;
    line-height: normal;
  }
`;

export const StyledHandle = styled(Handle)`
  width: 8px;
  height: 8px;
  background: #fff;
  border: 1px solid ${colors.darkGray3};
  border-radius: 50%;
  opacity: 1;
  position: absolute;
  z-index: 10;

  &:hover {
    border: 1px solid ${colors.darkGray1};
  }
  
  &.react-flow__handle-top {
    top: -4px;
    left: 50%;
    transform: translateX(-50%);
  }
  
  &.react-flow__handle-bottom {
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
  }
  
  &:hover {
    background: ${colors.gray2};
  }

  ${views.mobile} {
    width: 16px;
    height: 16px;
    
    &.react-flow__handle-top {
      top: -8px;
    }
    
    &.react-flow__handle-bottom {
      bottom: -8px;
    }
  }
`; 